export interface ISiteMetadata {
  title: string;
  description: string;
  keywords: string[];
  author: string;
  creator: string;
  publisher: string;
  robots: string;
  twitterHandle: string;
}

export interface ISiteConfig {
  name: string;
  description: string;
  url: string;
}

export const siteTitle = 'Cool Mate';
export const siteTagline = 'Your English mate';
export const siteDescription =
  'Cool Mate is your English mate, helping you understand and remember real English from movies, shows, and real life examples.';
export const siteDomain = 'yocoolmate.com';
export const siteUrl = `https://${siteDomain}`;

export const siteMetadata: ISiteMetadata = {
  title: siteTitle,
  description: siteDescription,
  keywords: ['coolmate'],
  author: 'Cool Mate',
  creator: 'Cool Mate',
  publisher: 'Cool Mate',
  robots: 'index, follow',
  twitterHandle: '@yocoolmate',
};

export const supportEmail = 'hi@yocoolmate.com';
export const legacyEmail = 'yoCoolMate+support@gmail.com';

export const privacyPolicyUrl = `${siteUrl}/privacy`;
export const termsOfServiceUrl = `${siteUrl}/terms`;
export const cookiesPolicyUrl = `${siteUrl}/cookies`;
export const dmcaPolicyUrl = `${siteUrl}/dmca`;
export const deleteAccountUrl = `${siteUrl}/delete-account`;

export const storyUrl = `${siteUrl}/story`;
export const aboutUrl = `${siteUrl}/about`;
export const visionUrl = `${siteUrl}/vision`;
export const missionUrl = `${siteUrl}/mission`;
export const valuesUrl = `${siteUrl}/values`;
export const socialResponsibilityUrl = `${siteUrl}/social-responsibility`;
export const brandUrl = `${siteUrl}/brand`;
export const statusPageUrl = `${siteUrl}/status`;

export const siteConfig: ISiteConfig = {
  name: siteTitle,
  description: siteDescription,
  url: siteUrl,
};
